"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearShoppingContextCache = clearShoppingContextCache;
var _basketProvider = require("@ori/basket-provider");
var _logger = require("../logger");
function clearShoppingContextCache() {
  if (typeof window !== 'object' || !window.localStorage) {
    (0, _logger.logWarning)(`localStorage is not supported. Can't set shopping context cache cleanup flag.`);
    return;
  }
  window.localStorage.setItem(_basketProvider.SCHEDULED_CLEANUP_KEY, '1');
  (0, _logger.logDebug)('Scheduled shopping context cache cleanup for next page load.');
}